import React, { SVGAttributes } from 'react';

export default function (props: SVGAttributes<SVGElement>) {
    return (
        <svg {...props} width="9" height="13" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 1l-5 5 5 5" stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd" />
        </svg>
    );
}
